import { Tabs } from 'antd';
import TabPane from 'antd/es/tabs/TabPane';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getFavoriteFiles } from '../../redux/FavoriteFiles/action';
import { getFavoriteCollection } from '../../redux/FavoriteCollection/action';
import ProductList from './ProductList';

const FavoriteActiveTab = ({activeTab, setActiveTab , favoriteFiles , favoriteCollection}) => {


    const handleTabChange = (key) => {
        setActiveTab(key);
    };


    return (
        <Tabs activeKey={activeTab} onChange={handleTabChange}>
            <TabPane tab="Files" key="files">
                <div style={{ width: '100%' }}>
                    <ProductList data={favoriteFiles} collectionData={{isCollection:false , name:'Files' , pagination:true}}/>
                </div>
            </TabPane>
            <TabPane tab="Collections" key="collections">
                <div style={{ width: '100%' }}>
                    <ProductList data={favoriteCollection} collectionData={{isCollection:true , name:'Collections' , pagination:true}}/>
                </div>
            </TabPane>
        </Tabs>
    );
};

export default FavoriteActiveTab;
